import { Routes } from '@angular/router';
import { VisorRdaComponent } from './pages';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'visor',
    pathMatch: 'full',
  },
  {
    path: 'visor',
    component: VisorRdaComponent,
    title: 'Visor Nacional de Historia Clínica - MinSalud',
  },
  {
    path: '**',
    redirectTo: 'visor',
  },
];
